import { removeHtmlTags } from './stringHelperMethods';

export const formatAmpersand = (inputString) => {
  try {
    return removeHtmlTags(inputString ?? '').replace('&amp;', '&');
  } catch (error) {
    console.error(error);
    return '';
  }
};
